import { Component, Input, OnInit } from '@angular/core';
import { ActionUserComponent } from './action-user/action-user.component';
import { ActionNavComponent } from './action-nav/action-nav.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { AuthService } from '../../services/apis/platform/auth.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, Observable, of, startWith, switchMap } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LoginComponent } from '../login/login.component';
import { MatDialog } from '@angular/material/dialog';
import { UserRegisterComponent } from '../user-register/user-register.component';
import { AutocompleteResult, SearchAutocompleteResponse } from '../../services/responses/platform/search-autocomplete.response';
import { SearchAutocompleteService } from '../../services/apis/platform/search-autocomplete.service';
import { ShoppingCartService } from '../../services/apis/platform/shopping-cart.service';
import { GetShoppingCartCountResponse } from '../../services/responses/platform/get-shopping-cart-count.response';
import { AlertService, AlertType } from '../../services/alert.service';

@Component({
  selector: 'app-menu',
  imports: [
    ActionUserComponent,
    ActionNavComponent,
    CommonModule,
    RouterModule,
    MatBadgeModule,
    MatAutocompleteModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css',
})
export class MenuComponent implements OnInit {
  public showActionUser: boolean = false;
  public showActionNav: boolean = false;
  public areThereNotifications: boolean = false;
  public isUserAuth: boolean = false;
  public cartCount: number = 0;

  public searchFormControl = new FormControl('');
  filteredOptions: Observable<AutocompleteResult[]>;

  @Input() isShowSearch = true;

  constructor(private authService: AuthService,
    public dialog: MatDialog,
    private searchAutocompleteService: SearchAutocompleteService,
    private router: Router,
    private route: ActivatedRoute,
    private shoppingCartService: ShoppingCartService,
    private alertService: AlertService) {
  }

  ngOnInit(): void {
    this.isUserAuth = this.authService.isAuthenticated();
    this.verifyCart();
    this.filteredOptions = this.searchFormControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(value => {
        if (value && value.length > 2) {
          return this.searchAutocompleteService.get(value).pipe(
            map((response: SearchAutocompleteResponse) => response.results)
          );
        } else {
          return of([]);
        }
      })
    );
  }

  onOptionSelected(option: AutocompleteResult): void {
    this.searchFormControl.setValue(option.bookTitle);
    this.router.navigate(['/livros'], { queryParams: { termo: option.bookTitle, idKit: option.idKit } });
  }

  buscar() {
    const termoDigitado = this.searchFormControl.value;
    this.router.navigate(['/livros'], { queryParams: { termo: termoDigitado } });
  }

  clickShowActionUser(action: any): void {
    if (!action) {
      this.showActionUser = !this.showActionUser;
      this.showActionNav = false;
      return;
    }

    this.showActionUser = action;
  }

  clickShowActionNav(action: any): void {
    if (!action) {
      this.showActionNav = !this.showActionNav;
      this.showActionUser = false;
      return;
    }

    this.showActionNav = action;
  }


  setAreThereNotifications(areThereNotifications: boolean): void {
    this.areThereNotifications = areThereNotifications;
  }

  openModalLogin() {
    const dialogRef = this.dialog.open(LoginComponent, {
      data: {},
      //panelClass: 'dialog-search-invite-client'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isUserAuth = this.authService.isAuthenticated();
    });
  }

  openModalRegister() {
    const dialogRef = this.dialog.open(UserRegisterComponent, {
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isUserAuth = this.authService.isAuthenticated();
    });
  }

  logout() {
    this.isUserAuth = this.authService.isAuthenticated();
    this.clickShowActionUser(false)
  }

  verifyCart() {
    this.shoppingCartService.getCount()
      .subscribe({
        next: (response: GetShoppingCartCountResponse) => {
          if (response.isError) {
            this.alertService.show('Erro', response.errorDescription, AlertType.error);
            return;
          }
          this.cartCount = response.count
        },
        error: () => {

          this.alertService.show('Erro', 'Não foi possível atualizar o item.', AlertType.error);
        }
      });
  }
}
